import app from '../../forum/app';
import Component from '../../common/Component';
import Button from '../../common/components/Button';
import LogInModal from './LogInModal';
import SignUpModal from './SignUpModal';
import SessionDropdown from './SessionDropdown';
import ChatRoom from './ChatRoom';
import SelectDropdown from '../../common/components/SelectDropdown';
import NotificationsDropdown from './NotificationsDropdown';
import ItemList from '../../common/utils/ItemList';
import listItems from '../../common/helpers/listItems';
import Search from '../components/Search';

/**
 * The `HeaderSecondary` component displays secondary header controls, such as
 * the search box and the user menu. On the default skin, these are shown on the
 * right side of the header.
 */
export default class HeaderSecondary extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    // 如果用户已登录，开始刷新未读数
    if (app.session.user && app.data.pkgLogo.chatStatus) {
      ChatRoom.startUnreadCountRefresh();
    }
  }

  onremove(vnode) {
    super.onremove(vnode);

    // 组件卸载时停止刷新
    ChatRoom.stopUnreadCountRefresh();
  }

  view() {
    return <ul className="Header-controls">{listItems(this.items().toArray())}</ul>;
  }

  /**
   * 获取指定频道的未读数显示
   * @param {string} channelId 频道ID
   * @returns {Mithril.Children} 未读数徽章
   */
  getUnreadBadge(channelId,type = 1) {
    if (!channelId) return null;

    const unreadData = ChatRoom.getUnreadCount(channelId,type);
    let num = 0;
    if (!unreadData || (unreadData.isUnread === 0 && unreadData.atNum === 0)) return null;
    const isUnread = unreadData.isUnread !== 0;
    num = unreadData.atNum;
    if (!isUnread) return null;
    return <span className="NotificationsDropdown-unread">{num > 99 ? '99' : num === 0 ? null : num}</span>;
  }

  /**
   * Build an item list for the controls.
   *
   * @return {ItemList}
   */
  items() {
    const items = new ItemList();

    // items.add('search', <Search state={app.search} />, 30);

    if (app.forum.attribute('showLanguageSelector') && Object.keys(app.data.locales).length > 1) {
      const locales = [];

      for (const locale in app.data.locales) {
        locales.push(
          <Button
            active={app.data.locale === locale}
            icon={app.data.locale === locale ? 'fas fa-check' : true}
            onclick={() => {
              if (app.session.user) {
                app.session.user.savePreferences({ locale }).then(() => window.location.reload());
              } else {
                document.cookie = `locale=${locale}; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT`;
                window.location.reload();
              }
            }}
          >
            {app.data.locales[locale]}
          </Button>
        );
      }

      items.add(
        'locale',
        <SelectDropdown
          buttonClassName="Button Button--link"
          accessibleToggleLabel={app.translator.trans('core.forum.header.locale_dropdown_accessible_label')}
        >
          {locales}
        </SelectDropdown>,
        100
      );
    }

    if (app.session.user) {
      if (app.data.pkgLogo.chatStatus) {
        const currentOpenimChat = app.data.currentOpenimChat;
        const chatRoom1Id = (currentOpenimChat && currentOpenimChat.chatRoomGroupId) || '';
        const chatRoom2Id = (currentOpenimChat && currentOpenimChat.userFeedbackGroupId) || '';
        const chatRoom3Id = (currentOpenimChat && currentOpenimChat.goodLuckGroupId) || '';
        const chatRoom4Id = (currentOpenimChat && currentOpenimChat.groupAdminId) || '';

        items.add(
          'chatRoom1',
          <ChatRoom channel="1" className="Button Button--flat ChatRoom-button" icon="fas fa-comments">
            <span>聊天室</span>
            {this.getUnreadBadge(chatRoom1Id)}
          </ChatRoom>,
          97
        );
        items.add(
          'chatRoom2',
          <ChatRoom channel="2" className="Button Button--flat ChatRoom-button" icon="fas fa-comments">
            <span>用户反馈</span>
            {this.getUnreadBadge(chatRoom2Id)}
          </ChatRoom>,
          97
        );
        items.add(
          'chatRoom3',
          <ChatRoom channel="3" className="Button Button--flat ChatRoom-button" icon="fas fa-comments">
            <span>好运时刻</span>
            {this.getUnreadBadge(chatRoom3Id)}
          </ChatRoom>,
          97
        );
        items.add(
          'chatRoom4',
          <ChatRoom channel="4" className="Button Button--flat ChatRoom-button" icon="fas fa-comments">
            <span>私讯</span>
            {this.getUnreadBadge(chatRoom4Id)}
          </ChatRoom>,
          97
        );
      }
      items.add('notifications', <NotificationsDropdown state={app.notifications} />, 90);
      items.add('session', <SessionDropdown />, 0);
    } else {
      if (app.forum.attribute('allowSignUp')) {
        items.add(
          'signUp',
          <Button className="Button Button--link" onclick={() => app.modal.show(SignUpModal)}>
            {app.translator.trans('core.forum.header.sign_up_link')}
          </Button>,
          85
        );
      }

      items.add(
        'logIn',
        <Button className="Button Button--link" onclick={() => app.modal.show(LogInModal)}>
          {app.translator.trans('core.forum.header.log_in_link')}
        </Button>,
        80
      );
    }

    return items;
  }
}
